import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Manage Tires</h3>
                <p className="text-sm text-gray-600">
                    Track the lifecycle and status of tires in your fleet.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Adding Tires</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click <strong>Add Tire</strong> to register a new tire.</li>
                    <li>Record details such as <strong>Brand</strong>, <strong>Model</strong>, <strong>Size</strong>, <strong>Season</strong>, and <strong>TIN</strong> (Tire Identification Number).</li>
                    <li>Assign tires to specific <strong>Vehicles</strong> and <strong>Positions</strong>.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Inventory Management</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Use the <strong>Search Bar</strong> to locate tires by ID or brand.</li>
                    <li>Monitor tire <strong>Status</strong> (e.g., In Use, Spare, Scrapped).</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Export Data</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Select tires using the checkboxes and click <strong>PDF</strong> or <strong>CSV</strong> to generate an inventory report.</li>
                </ul>
            </section>
        </div>
    );
};

export default Help;
